import type { Maybe } from '@adornis/base/utilTypes.js';
import { ActivatedRegisterType, SchoolType } from '../entities/School.js';

export function getPossibleKlassenForSchoolType(
  schoolType: Maybe<SchoolType>,
  mode: Maybe<ActivatedRegisterType>,
): string[] {
  if (mode === ActivatedRegisterType.ELEMENTARY_HIGH) {
    return ['5'];
  }

  if (!schoolType) return [];
  switch (schoolType) {
    case SchoolType.GRUNDSCHULE:
      return mode === ActivatedRegisterType.SCHOOL_SCHOOL ? ['2', '3', '4'] : ['1', '2', '3', '4'];
    case SchoolType.HAUPTSCHULE:
    case SchoolType.REALSCHULE:
      return mode === ActivatedRegisterType.SCHOOL_SCHOOL
        ? ['6', '7', '8', '9', '10']
        : ['5', '6', '7', '8', '9', '10'];
    case SchoolType.GYMNASIUM:
      return mode === ActivatedRegisterType.SCHOOL_SCHOOL
        ? ['6', '7', '8', '9', '10', 'E', 'Q1', 'Q3']
        : ['5', '6', '7', '8', '9', '10', 'E', 'Q1', 'Q3'];
  }
}

export function getPossibleKlassenForSchoolTypeAbstract(schoolType: Maybe<SchoolType>): string[] {
  if (!schoolType) return [];
  switch (schoolType) {
    case SchoolType.GRUNDSCHULE:
      return ['1', '2', '3', '4'];
    case SchoolType.HAUPTSCHULE:
    case SchoolType.REALSCHULE:
      return ['5', '6', '7', '8', '9', '10'];
    case SchoolType.GYMNASIUM:
      return ['5', '6', '7', '8', '9', '10', 'E', 'Q1', 'Q3'];
  }
}

/** Upper secondary stages are named as such, all others read "5. Klasse". */
export const klasseLabel = (klasse: string) => (['E', 'Q1', 'Q3'].includes(klasse) ? klasse : `${klasse}. Klasse`);
